import { createSlice } from "@reduxjs/toolkit";

//user can create any number of activities so 'activities' is an array of objects.
//activityType and subtype will be there in every activity object other keys will depend on activity type.
//keys will be based on the activity type.
//isActive ie. selected activity will be displayed in the activity design box

const initialState = {
  activities: [],
  selectedActivity: 0,
  userActivities: [],
};

// activity slice which the user is designing
const activity = createSlice({
  name: "activity",
  initialState,
  reducers: {
    setActivities: (state, { payload }) => {
      state.activities = payload;
    },
    addUserActivity: (state, { payload }) => {
      state.userActivities = payload;
    },
    selectActivity: (state, { payload }) => {
      state.selectedActivity = payload;
    },
    setActivity: (state, { payload }) => {
      state.activities[state.selectedActivity] = payload;
    },
  },
});

export const { setActivities, setActivity, selectActivity, addUserActivity } = activity.actions;
export default activity.reducer;
